module.exports = __webpack_public_path__ + "img/Special-Mug.dc8a8104.svg";